<template>
  <div class="new-page-con">
    <!-- <Home></Home> -->
    <Header @onSearch="onSearch">
      <!-- 工具栏 -->
      <Tollbar :list="tollbarList" type="1" theme="1" isFilterDis></Tollbar>
    </Header>
    <div class="new-content-con new-content-detail-con">
      <div class="new-content-home-top margin-b20">
        <div class="new-content-home-item">
          <div class="new-content-home-title">
            New sanction data added in the past month
          </div>
          <div class="new-content-home-number">{{ 0 | FilterNum }}</div>
          <!-- <div class="new-content-home-percentage new-content-home-percentage">
            <i class="iconfont icon-xiajiang"></i><span>10%</span>
            decrease since last month
          </div> -->
        </div>
        <div class="new-content-home-item">
          <div class="new-content-home-title">Add company data</div>
          <div class="new-content-home-number">{{ 0 | FilterNum }}</div>
          <!-- <div class="new-content-home-percentage new-content-home-rise">
            <i class="iconfont icon-shangsheng"></i><span>10%</span>
            increase since last month
          </div> -->
        </div>
        <div class="new-content-home-item">
          <div class="new-content-home-title">Add personal data</div>
          <div class="new-content-home-number">{{ 0 | FilterNum }}</div>
          <!-- <div class="new-content-home-percentage new-content-home-rise">
            <i class="iconfont icon-shangsheng"></i><span>10%</span>
            increase since last month
          </div> -->
        </div>
        <div class="new-content-home-item">
          <div class="new-content-home-title">Add product data</div>
          <div class="new-content-home-number">{{ 0 | FilterNum }}</div>
          <!-- <div class="new-content-home-percentage new-content-home-rise">
            <i class="iconfont icon-shangsheng"></i><span>10%</span>
            increase since last month
          </div> -->
        </div>
        <div class="new-content-home-item">
          <div class="new-content-home-title">
            The country with the most newly imposed sanctions
          </div>
          <div class="new-content-home-number">{{ 0 | FilterNum }}</div>
          <!-- <div class="new-content-home-percentage new-content-home-rise">
            <i class="iconfont icon-shangsheng"></i><span>10%</span>
            increase since last month
          </div> -->
        </div>
        <div class="new-content-home-item">
          <div class="new-content-home-title">
            The company with the most new sanctions
          </div>
          <div class="new-content-home-number">{{ 0 | FilterNum }}</div>
          <!-- <div class="new-content-home-percentage new-content-home-rise">
            <i class="iconfont icon-shangsheng"></i><span>10%</span>
            increase since last month
          </div> -->
        </div>
      </div>
      <div class="new-content-home-desc margin-b20">
        New sanction data added in the past month 0：company data 0，personal
        data 0，product data 0
      </div>
      <!-- 列表 -->
      <div class="new-content-right">
        <div class="new-table-box" v-loading="loading">
          <el-table
            :data="tableData"
            row-key="id"
            class="new-table-con"
            height="100%"
          >
            <el-table-column
              prop="id"
              label="Sanctions ID"
              width="165"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row?.sanctionsId ? scope.row?.sanctionsId : "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="sanctions"
              label="Object of Sanctions"
              min-width="235"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row?.sanctions ? scope.row?.sanctions : "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="sanctionsCountry"
              label="Sanctioned Countries"
              min-width="255"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{
                  scope.row?.sanctionsCountry
                    ? scope.row?.sanctionsCountry
                    : "-"
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="companyName"
              label="Name"
              min-width="255"
              class-name="hover-cell"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row?.companyName ? scope.row?.companyName : "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="countryName"
              label="Country"
              width="150"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row?.countryName ? scope.row.countryName : "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="source"
              label="Source"
              min-width="150"
              class-name="two-column-cell"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row?.source ? scope.row.source : "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="fromTime"
              label="Form"
              min-width="150"
              class-name="two-column-cell"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row?.fromTime ? scope.row.fromTime : "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="toTime"
              label="To"
              min-width="150"
              class-name="two-column-cell"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row?.toTime ? scope.row.toTime : "-" }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Home from "@/views/newLayout/home.vue";
import Header from "@/views/newLayout/header.vue";
import Tollbar from "@/views/newLayout/tollbar.vue";

export default {
  components: {
    Header,
    Home,
    Tollbar,
  },
  data() {
    return {
      loading: false,
      tableData: [],
      //   工具栏
      tollbarList: [
        {
          icon: "icon-youhua",
          name: "Optimize",
          disabled: true,
        },
        {
          icon: "icon-xuanze",
          name: "Select",
          disabled: true,
        },
        {
          icon: "icon-bianji1",
          name: "Edit",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-filter",
          name: "Sort by",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-shoucang1",
          name: "Collect",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-baocun",
          name: "Saved",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-icon_xinyong_xianxing_jijin-307",
          name: "Compare",
          disabled: true,
        },
        {
          icon: "icon-daochu04",
          name: "Export",
          disabled: true,
        },
        {
          icon: "icon-xiazai",
          name: "Download",
          disabled: true,
        },
        {
          icon: "icon-shuaxin",
          name: "Update",
          disabled: true,
        },
        {
          icon: "icon-judan",
          name: "Report Error",
          disabled: true,
        },
        {
          icon: "icon-gudong",
          name: "Share",
          disabled: true,
        },
      ],
    };
  },
  methods: {
    // 搜索
    onSearch(params) {
      if (params.selectCode == 1) {
        // 公司
        this.$router.push({
          path: "/sanction/companyList",
          query: {
            selectCode: 1,
            keyword: params.searchKeyword,
          },
        });
      } else if (params.selectCode == 2) {
        // 个人
        this.$router.push({
          path: "/sanction/personList",
          query: {
            selectCode: 2,
            keyword: params.searchKeyword,
          },
        });
      } else if (params.selectCode == 3) {
        // 产品
        this.$router.push({
          path: "/sanction/productList",
          query: {
            selectCode: 3,
            keyword: params.searchKeyword,
          },
        });
      } else if (params.selectCode == 4) {
        // 国家
        this.$router.push({
          path: "/sanction/countryList",
          query: {
            selectCode: 4,
            keyword: params.searchKeyword,
          },
        });
      }
    },
  },
};
</script>
<style scoped>
.new-content-detail-con {
  padding: 10px !important;
}
.new-content-home-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 178px;
  padding: 14px;
  flex-shrink: 0;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}
.new-content-home-item {
  width: 300px;
  height: 150px;
  padding: 14px 16px;
  background: linear-gradient(136deg, #ffe1d2 0%, #fff7f3 51%, #ffd1b9 100%);
  border-radius: 4px;
}
.new-content-home-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: box; /* Fallback for old syntax */
  -webkit-line-clamp: 2; /* Limit lines to 2 */
  line-clamp: 2; /* Non-standard but supported by most modern browsers */
  width: 100%;
  height: 40px;
  margin-bottom: 16px;
  font-family: "DMSans Bold";
  font-size: 16px;
  color: #1a2332;
  line-height: 20px;
  text-align: left;
}
.new-content-home-number {
  line-height: 34px;
  margin-bottom: 14px;
  font-family: "DMSans Bold";
  font-size: 30px;
  color: #ff5e0b;
}
.new-content-home-percentage {
  display: flex;
  align-items: center;
  justify-content: start;
  line-height: 18px;
  font-size: 14px;
  color: #666666;
}
.new-content-home-percentage i {
  margin-right: 6px;
   font-family: "DMSans Bold";
  font-size: 22px;
  color: #ff1f1f;
}
.new-content-home-percentage span {
  margin-right: 10px;
  font-family: "DMSans Bold";
  font-size: 18px;
  color: #ff1f1f;
}
.new-content-home-rise.new-content-home-percentage i,
.new-content-home-rise.new-content-home-percentage span {
  color: #00c753;
}
.new-content-home-desc {
  font-family: "DMSans Bold";
  font-size: 16px;
}
.new-content-right {
  flex: none;
  height: 688px;
  padding: 15px;
  margin-right: 0;
}
</style>
